import {useEffect, useRef} from "react";

export const useImageDirection = (ref, currentIndex, imageList, setCurrentIndex, setCurrentUrl) => {
    let isLast = false
    let isFirst = false

    if (currentIndex === imageList.length - 1) {
        isLast = true
    }
    if (currentIndex === 0) {
        isFirst = true
    }

    const onClickNext = () => {
        if (currentIndex === imageList.length - 1) {
            return
        }
        const newFileIndex = currentIndex + 1
        setCurrentIndex(newFileIndex)
        setCurrentUrl({file: imageList[newFileIndex].file, previewUrl: imageList[newFileIndex].previewUrl})
    }
    const onClickPrev = () => {
        if (currentIndex === 0) {
            return
        }
        const newFileIndex = currentIndex - 1
        setCurrentIndex(newFileIndex)
        setCurrentUrl({file: imageList[newFileIndex].file, previewUrl: imageList[newFileIndex].previewUrl})
    }

    const currentRef = useRef(ref);

    useEffect(() => {
        const moveDirectionFile = (evt) => {
            if (evt.key === 'ArrowLeft') {
                onClickPrev()
            }
            if (evt.key === 'ArrowRight') {
                onClickNext()
            }
        }

        if (currentRef && currentRef.current) {
            window.addEventListener('keydown', moveDirectionFile)
        }

        return () => {
            window.removeEventListener('keydown', moveDirectionFile)
        }
    }, [onClickNext, onClickPrev]);

    return {isLast, isFirst, onClickPrev, onClickNext}
}